<template>
    <div>
        <p v-if="data.payment_type" class="items"> {{data.payment_type}}</p>

        <button v-else class="btn btn-sm text-light"  data-bs-toggle="tooltip" data-bs-placement="right" title="Add Payment Type" type="button"
        data-toggle="modal"
        @click="click(data)"
        data-target="#group-access">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
            </svg>
        </button>
    </div>
</template>
<script>
export default {
    props: {
        data: {},
        name: {},
        click: {
            type: Function,
            default: () => {
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    .items {
        text-transform: capitalize;
    }
    button {
        border: none;
        background: none;
        outline: 0;

        svg {
            width: 18px;
            height: 18px;
            color: #3490dc;
        }
    }
</style>
